/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { replacePXinStringWithEM, pxToEm } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// STEP INDICATOR : STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
	stepindicator: {
		background: theme.color.light.light.swatch,
		borderTop: replacePXinStringWithEM(`1px solid #E8EBF2`),
		borderBottom: replacePXinStringWithEM(`1px solid #E8EBF2`),
		display: 'flex',
		flexWrap: 'wrap',
		justifyContent: 'center',
		alignContent: 'center',
		alignItems: 'center',
		textAlign: 'center',
		position: 'relative',
		zIndex: '2',
		width: '100%',
		overflow: 'hidden',
		'&.isNewEmbedFlow-true': {
			'&.code': {
				'& .step': {
					pointerEvents: 'none !important' // don't allow users to navigate via steps when they're getting code
				}
			}
		}
	},

	// ((((((((((((((( MEDIA QUERIES ))))))))))))))) //
	[`@media only screen and (min-width:${pxToEm(0)}) and (max-width:${pxToEm(740)})`]: {
		stepindicator: {
			borderBottom: 'none',
			paddingBottom: pxToEm(20),
			paddingLeft: theme.spacing.sides,
			paddingRight: theme.spacing.sides,
			justifyContent: 'flex-start'
		}
	}
});